import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { DateRange, DateRangePicker, LocalizationProvider, SingleInputDateRangeField } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs from "dayjs";
import { Dispatch, SetStateAction, useContext } from "react";
import ReassignButtonAndModal from "../reports/ReassignButtonAndModal";
import TotalAmount from "./TotalAmount";
import { ChecksContext } from "./ChecksContext";
import { DashboardReportType } from "../types/reports";

interface IProps {
  dateRange: DateRange<dayjs.Dayjs>;
  setDateRange: Dispatch<SetStateAction<DateRange<dayjs.Dayjs>>>;
  assignedToMe: boolean;
  setAssignedToMe: Dispatch<SetStateAction<boolean>>;
  assignedToMyTeam: boolean;
  setAssignedToMyTeam: Dispatch<SetStateAction<boolean>>;
  table: any;
  hideAssignedToMeOptions: boolean;
  onRowsDeselected: () => void;
  isUserManagerOrTME: boolean;
}

export default function CheckActions({
  dateRange,
  setDateRange,
  assignedToMe,
  setAssignedToMe,
  assignedToMyTeam,
  setAssignedToMyTeam,
  table,
  hideAssignedToMeOptions,
  onRowsDeselected,
  isUserManagerOrTME
}: IProps) {
  const { fetchChecks } = useContext(ChecksContext);
  return (
    <Stack direction="row" spacing={4} alignItems="center">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateRangePicker
          value={dateRange}
          localeText={{
            start: "Transaction-Start-Date",
            end: "Transaction-End-Date"
          }}
          onAccept={(newValue) => {
            setDateRange(newValue);
          }}
          format="MM/DD/YY"
          calendars={3}
          slotProps={{ textField: { size: "small" } }}
          slots={{ field: SingleInputDateRangeField }}
          sx={{ width: 220 }}
        />
      </LocalizationProvider>
      <TotalAmount table={table} />
      {!hideAssignedToMeOptions && (
        <FormControlLabel
          control={<Checkbox checked={assignedToMe} onChange={(_, value) => setAssignedToMe(value)} />}
          label="Assigned to me"
        />
      )}
      {!hideAssignedToMeOptions && isUserManagerOrTME && (
        <FormControlLabel
          control={<Checkbox checked={assignedToMyTeam} onChange={(_, value) => setAssignedToMyTeam(value)} />}
          label="Assigned to my team"
        />
      )}
      <ReassignButtonAndModal
        table={table}
        fetchTableData={fetchChecks}
        reportType={DashboardReportType.OutstandingChecks}
        onRowsDeselected={onRowsDeselected}
      />
    </Stack>
  );
}
